export default __webpack_public_path__ + "static/media/arcanebacklash.232a1f4f.png";